module.exports = __webpack_public_path__ + "media/goforajourney/img/marrakech-card-82a22690add1508541ccc35cf3f8a510.webp";